import moment from 'moment';

import { getDateInUTCFormat } from '@utils/dateUtil';

function groupDatesWithRanges(dates: string[]): string[] {
  const groupedByMonth: { [month: string]: number[] } = {};

  // Parse and group dates
  for (const dateStr of dates) {
    // Extract day and month
    const [dayStr, month] = dateStr.split(' '); // Split by space
    const day = parseInt(dayStr, 10); // Parse day as a number

    // Group by month, collecting days
    if (!groupedByMonth[month]) {
      groupedByMonth[month] = [];
    }
    groupedByMonth[month].push(day);
  }

  // Format grouped results
  const result: string[] = [];
  for (const [month, days] of Object.entries(groupedByMonth)) {
    // Sort the days
    days.sort((a, b) => a - b);

    // Create the range string
    const sortingDays = [...new Set(days)];
    const sortingDaysStr = sortingDays.join('-');

    // Append to the result array
    result.push(`${sortingDaysStr} ${month}`);
  }

  return result;
}

export function groupDatesByMonth(dates: string[]): string {
  return groupDatesWithRanges(
    dates?.map((date) => getDateInUTCFormat(date, 'DD MMMM'))
  )?.join(', ');
}

export function findClosestDate(
  dates: string[],
  targetDate: string
): moment.Moment | null {
  const targetMoment = moment(targetDate);

  let closestDate: moment.Moment | null = null;
  let smallestDiff = Infinity;

  for (const dateString of dates) {
    const currentMoment = moment(dateString);
    const diff = Math.abs(currentMoment.diff(targetMoment));

    if (diff < smallestDiff) {
      closestDate = currentMoment;
      smallestDiff = diff;
    }
  }

  return closestDate;
}
